import "./Home.module.css";
import NavigationHeader from "@/reusable_sections/Header";
import BrandLogos from "./sections/BrandLogos";
import TheGrowthAuthority from "./sections/TheGrowthAuthority";
import SolutionsGrid from "./sections/SolutionsGrid";
import CustomerReviews from "./sections/CustomerReviews";
import SecureYourAssets from "./sections/SecureYourAssets";
import TheTampaGreenGuide from "./sections/TheTampaGreenGuide";
import Footer from "@/reusable_sections/Footer";
import Hero from "./sections/Hero";
export default function HomePage() {
  return <div>
      <NavigationHeader />
      
      
      
      <Hero />   
      <BrandLogos />
      <TheGrowthAuthority />
      <SolutionsGrid />
      <CustomerReviews />
      <SecureYourAssets />
      <TheTampaGreenGuide />
      <Footer />
    </div>;
}